/*
 * Bear of PA - cart integrity fixes
 * Deployed 2026-09-08. Source: shopify/THEME-BATCH-2026-09-03.md items 2 and 4.
 *
 * Fix A: purge orphaned Custom Product Upcharge lines.
 * Fix B: hide the quantity stepper on configured playset rows.
 *
 * Both are read-then-repair and both no-op when they find nothing, so the
 * failure mode is "does nothing", never "breaks the cart".
 */
(function () {
  'use strict';

  var UPCHARGE_PRODUCT_ID = 8994271461455;
  var CONFIG_KEY = '_Configuration ID';

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* ---------------------------------------------------------------- Fix A */

  var purging = false;

  function purgeOrphanUpcharges() {
    if (purging) return Promise.resolve();
    purging = true;

    return getCart()
      .then(function (cart) {
        var live = {};
        cart.items.forEach(function (item) {
          if (item.product_id === UPCHARGE_PRODUCT_ID) return;
          var id = (item.properties || {})[CONFIG_KEY];
          if (id) live[id] = true;
        });

        var upcharges = cart.items.filter(function (item) {
          return item.product_id === UPCHARGE_PRODUCT_ID;
        });
        var realItems = cart.items.length - upcharges.length;
        var liveCount = Object.keys(live).length;

        if (!upcharges.length) return;

        /* SAFETY GUARD.
         * If no configuration IDs were found but the cart still holds real
         * products, we cannot tell which upcharges belong to them. The property
         * name may have changed. Purging here would strip legitimate upcharges
         * and undercharge the customer, so do nothing and say so.
         *
         * The documented broken state is a cart holding ONLY hidden upcharge
         * lines and no visible products. That case is unambiguous and is still
         * repaired below. */
        if (liveCount === 0 && realItems > 0) {
          if (window.console && console.warn) {
            console.warn('[bear] upcharge lines present but no "' + CONFIG_KEY +
                         '" found on any product line. Skipping purge to avoid ' +
                         'removing valid upcharges. Check the property name.');
          }
          return;
        }

        var orphans = upcharges.filter(function (item) {
          return !live[(item.properties || {})[CONFIG_KEY]];
        });

        if (!orphans.length) return;

        return orphans.reduce(function (chain, orphan) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ id: orphan.key, quantity: 0 })
            });
          });
        }, Promise.resolve()).then(function () {
          if (window.console && console.info) {
            console.info('[bear] purged ' + orphans.length + ' orphaned upcharge line(s)');
          }
        });
      })
      .catch(function (e) {
        if (window.console && console.warn) console.warn('[bear] purge failed', e);
      })
      .then(function () { purging = false; });
  }

  /* ---------------------------------------------------------------- Fix B */

  function lockConfiguredRows() {
    return getCart()
      .then(function (cart) {
        var keys = cart.items
          .filter(function (item) { return (item.properties || {})[CONFIG_KEY]; })
          .map(function (item) { return item.key; });

        if (!keys.length) return;

        keys.forEach(function (key) {
          var anchors = document.querySelectorAll(
            '[data-line-key="' + key + '"],' +
            '[data-key="' + key + '"],' +
            '[name="updates[' + key + ']"],' +
            '[data-variant-id="' + key + '"]'
          );

          anchors.forEach(function (node) {
            var row = node.closest('[data-line-key], [data-key], tr, li, .cart-item') ||
                      node.parentElement;
            if (!row) return;

            row.querySelectorAll(
              'quantity-selector-component, .quantity-selector, .quantity, ' +
              'input[name^="updates"]'
            ).forEach(function (control) {
              if (control.dataset.bearLocked === '1') return;
              control.dataset.bearLocked = '1';
              control.style.display = 'none';
            });
          });
        });
      })
      .catch(function (e) {
        if (window.console && console.warn) console.warn('[bear] stepper lock failed', e);
      });
  }

  /* --------------------------------------------------------------- Runner */

  function run() {
    purgeOrphanUpcharges().then(lockConfiguredRows);
  }

  function watch() {
    run();

    var targets = document.querySelectorAll(
      '[id^="shopify-section"][id*="cart"], cart-drawer-component'
    );
    if (!targets.length) return;

    var timer;
    targets.forEach(function (target) {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(run, 400);
      }).observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();